<template>
  <b-container fluid>
    <div class="content-card">
      <page-header title="Pronóstico Comercial" @back="volverAtras" />
      <FiltrosOfertas @filtrar="filtrosCambiados" />
      <GraficaActividadPendientes :items="items" />
      <TablaPronosticoComercial :items="items" />
    </div>
  </b-container>
</template>

<script>
import FiltrosOfertas from "@/views/ofertas/Listar/FiltrosOfertas.vue";
import { useFiltrosOfertaFormStore } from "@/stores/FiltrosOfertaForm";
import { tablaPronosticoComercial } from "@/services/productividadComercial.js";
import TablaPronosticoComercial from "./TablaPronosticoComercial.vue";
import GraficaActividadPendientes from "./GraficaActividadPendientes.vue";

export default {
  components: {
    FiltrosOfertas,
    TablaPronosticoComercial,
    GraficaActividadPendientes,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    volverAtras() {
      this.$router.push("/ofertas");
    },
    async actualizarDatos() {
      const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
      const params = Object.assign({}, filtrosOfertaFormStore.filtrosAplicables);
      const items = await tablaPronosticoComercial(params);

      const totalArr = items.reduce((sum, item) => sum + item.arrPendiente, 0);
      items.forEach((item) => {
        item.contribucionARR = totalArr ? (item.arrPendiente * 100) / totalArr : 0;
      });

      this.items = items;
    },
    filtrosCambiados() {
      this.actualizarDatos();
    },
  },
  async mounted() {
    const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
    await filtrosOfertaFormStore.actualizarFiltrosAplicables();
    await this.actualizarDatos();
  },
};
</script>
